import { c as _c } from "react/compiler-runtime";
import { ordinal } from '@/shared/text';

/**
 * DateBadge - Displays either a date range badge or a single date badge
 * @param {Object} badgeStart - { mon: 'Jul', day: '31' }
 * @param {Object} badgeEnd - { mon: 'Aug', day: '1' }
 */
export default function DateBadge(t0) {
  const $ = _c(21);
  const {
    badgeStart,
    badgeEnd
  } = t0;
  if (!badgeStart) {
    return null;
  }
  const isSingleDate = !badgeEnd || badgeStart.mon === badgeEnd.mon && badgeStart.day === badgeEnd.day;
  if (isSingleDate) {
    let t1;
    if ($[0] !== badgeStart.mon) {
      t1 = <div className="text-base font-medium leading-tight tracking-wide">{badgeStart.mon}</div>;
      $[0] = badgeStart.mon;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== badgeStart.day) {
      t2 = <div className="text-[36px] font-bold leading-none mt-1">{badgeStart.day}</div>;
      $[2] = badgeStart.day;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <div className="flex items-center justify-center w-[75px] h-[75px] rounded-full bg-black/40 backdrop-blur-sm text-white shadow-lg"><div className="text-center">{t1}{t2}</div></div>;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t1;
  if ($[7] !== badgeEnd.mon || $[8] !== badgeStart.mon) {
    t1 = <div className="text-sm font-medium leading-tight tracking-wide mb-1">{badgeStart.mon} - {badgeEnd.mon}</div>;
    $[7] = badgeEnd.mon;
    $[8] = badgeStart.mon;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const t2 = parseInt(badgeStart.day, 10);
  let t3;
  if ($[10] !== t2) {
    t3 = ordinal(t2);
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="mx-1">-</span>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = parseInt(badgeEnd.day, 10);
  let t6;
  if ($[13] !== t5) {
    t6 = ordinal(t5);
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t6) {
    t7 = <div className="text-[28px] font-bold leading-none tracking-tight">{t3}{t4}{t6}</div>;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t7) {
    t8 = <div className="inline-flex flex-col items-center justify-center px-6 py-4 rounded-[20px] bg-black/40 backdrop-blur-sm text-white shadow-lg min-w-[160px]">{t1}{t7}</div>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}